import React from "react";
import UserList from "../../Components/Member/UserList";
// import LeftMenu from "../../Components/LeftMenu";
import queryString from "query-string";

const UserListPage = ({ match, location }) => {
  const query = queryString.parse(location.search);
  return (
    <React.Fragment>
      {/* <LeftMenu /> */}
      <UserList
        pageNumber={query.pageNumber}
        search={query.search}
        type={query.type}
      />
    </React.Fragment>
  );
};

export default UserListPage;
